export enum PublicRouteName {
    REQUEST_LINK_CONFIRMATION = 0,
    PUBLIC_REQUEST_TOKEN = 1,
    PUBLIC_REQUEST_SEARCH = 2,
}

export type PublicRoute = {
    path: string;
};

export const publicRoutes: Record<PublicRouteName, PublicRoute> = {
    [PublicRouteName.REQUEST_LINK_CONFIRMATION]: {
        path: "/request-link/confirmation/:id",
    },
    [PublicRouteName.PUBLIC_REQUEST_TOKEN]: {
        path: "/public-request/:token",
    },
    [PublicRouteName.PUBLIC_REQUEST_SEARCH]: {
        path: "/public-request/new/:requestMasterTypeId",
    },
};

export const getPublicPath = (routeName: PublicRouteName): string => {
    return publicRoutes[routeName].path;
};

export const buildPublicSearchPath = (requestMasterTypeId: string): string =>
    publicRoutes[PublicRouteName.PUBLIC_REQUEST_SEARCH].path.replace(
        ":requestMasterTypeId",
        encodeURIComponent(requestMasterTypeId)
    );

export const buildPublicTokenPath = (token: string): string =>
    publicRoutes[PublicRouteName.PUBLIC_REQUEST_TOKEN].path.replace(
        ":token",
        encodeURIComponent(token)
    );
